function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var Web3PaymentTemplate = require('./web3-payment.template');
var _require = require('../../email'),
  sendInsufficientFundsFollowup = _require.sendInsufficientFundsFollowup;
var INSTRUCTION_TIMEOUT_MS = 35000;
function isWeb3Ticker() {
  var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var symbol = String(ticker || '').trim().toUpperCase();
  return symbol !== '' && symbol !== 'SAITO';
}
function scaleAmount(amount, quantity) {
  var qty = Math.max(1, Math.floor(Number(quantity) || 1));
  var raw = String(amount !== null && amount !== void 0 ? amount : '').trim();
  if (!/^\d+(\.\d+)?$/.test(raw)) {
    return '';
  }
  var _raw$split = raw.split('.'),
    _raw$split2 = _slicedToArray(_raw$split, 2),
    whole = _raw$split2[0],
    _raw$split2$ = _raw$split2[1],
    fraction = _raw$split2$ === void 0 ? '' : _raw$split2$;
  var digits = "".concat(whole).concat(fraction).replace(/^0+/, '') || '0';
  var product = (BigInt(digits) * BigInt(qty)).toString().padStart(fraction.length + 1, '0');
  if (!fraction.length) {
    return product;
  }
  var cut = product.length - fraction.length;
  var head = product.slice(0, cut);
  var tail = product.slice(cut).replace(/0+$/, '');
  return tail ? "".concat(head, ".").concat(tail) : head;
}
var Web3PaymentOverlay = /*#__PURE__*/function () {
  function Web3PaymentOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, Web3PaymentOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true);
    this.overlay.clickBackdropToClose = false;
    this.session = 0;
    this.active = false;
    this.resetState();
    app.connection.on('saito-purchase-address-reserved', function (data) {
      _this.receiveAddress(data);
    });
    app.connection.on('saito-purchase-payment-detected', function (data) {
      _this.receivePaymentDetected(data);
    });
    app.connection.on('saito-purchase-error-notification', function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.receiveError(data);
    });
    app.connection.on('saito-purchase-saito-issued', function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.receiveIssued(data);
    });
    app.connection.on('store-purchase-asset', function (data) {
      _this.receiveStorePurchase(data);
    });
  }
  return _createClass(Web3PaymentOverlay, [{
    key: "resetState",
    value: function resetState() {
      this.summary = null;
      this.quantity = 1;
      this.note = '';
      this.title = '';
      this.ticker = '';
      this.expected_deposit = '';
      this.destination = '';
      this.mixin_id = '';
      this.reserved_until = 0;
      this.reservation = null;
      this.payer = '';
      this.crypto_selected = null;
      this.purchase_tx = null;
      this.payment_detected = false;
      this.fulfillment_monitor = false;
      this.internal_payment_pending = false;
      this.internal_payment_sending = false;
      this.statusLead = '';
      this.fundsNotice = false;
      this.followupSent = false;
      this.followupEmail = '';
      this.followupError = '';
      this.addressRequestFailed = false;
      this.instruction_timer = null;
      this.reservation_timer = null;
    }
  }, {
    key: "isWeb3Summary",
    value: function isWeb3Summary(summary) {
      return isWeb3Ticker(summary === null || summary === void 0 ? void 0 : summary.web3_ticker);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(summary) {
        var _summary$returnTitle, _this$mod$main, _this$mod$main$close, _this$mod$purchase_li, _this$mod$purchase_li2;
        var quantity,
          _ref,
          _ref$note,
          note,
          ticker,
          unitAmount,
          deposit,
          session,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              quantity = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$note = _ref.note, note = _ref$note === void 0 ? '' : _ref$note;
              ticker = String((summary === null || summary === void 0 ? void 0 : summary.web3_ticker) || '').trim().toUpperCase();
              unitAmount = String((summary === null || summary === void 0 ? void 0 : summary.web3_amount) || '').trim();
              deposit = scaleAmount(unitAmount, quantity);
              if (!(!(summary !== null && summary !== void 0 && summary.nft_id) || !isWeb3Ticker(ticker) || !deposit)) {
                _context.n = 1;
                break;
              }
              salert('This item does not have a valid crypto price.');
              return _context.a(2);
            case 1:
              this.session += 1;
              session = this.session;
              this.clearTimers();
              this.active = true;
              this.resetState();
              this.summary = summary;
              this.quantity = Math.max(1, Math.floor(Number(quantity) || 1));
              this.note = String(note || '').trim();
              this.title = ((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'this item';
              this.ticker = ticker;
              this.expected_deposit = deposit;
              this.statusLead = 'Requesting a payment address...';
              (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.listing_detail) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.overlay) === null || _this$mod$main === void 0 || (_this$mod$main$close = _this$mod$main.close) === null || _this$mod$main$close === void 0 || _this$mod$main$close.call(_this$mod$main);
              (_this$mod$purchase_li = this.mod.purchase_lifecycle) === null || _this$mod$purchase_li === void 0 || (_this$mod$purchase_li2 = _this$mod$purchase_li.hideListing) === null || _this$mod$purchase_li2 === void 0 || _this$mod$purchase_li2.call(_this$mod$purchase_li, summary);
              this.render();
              _context.p = 2;
              this.crypto_selected = this.cachedCurrency() || {
                ticker: ticker
              };
              _context.n = 3;
              return this.checkForLocalCrypto(session);
            case 3:
              if (!(!this.active || this.session !== session)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              _context.n = 5;
              return this.mod.createPurchaseAssetTransaction(summary, {
                price: '0',
                fee: String(this.mod.fee || 0),
                quantity: this.quantity,
                note: this.note,
                web3: true
              }, 0n);
            case 5:
              this.purchase_tx = _context.v;
              _context.n = 6;
              return this.requestAddress();
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error('Store: web3 payment failed to start', _t);
              if (this.active && this.session === session) {
                this.fail((_t === null || _t === void 0 ? void 0 : _t.message) || 'Could not start this payment.');
              }
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[2, 7]]);
      }));
      function start(_x) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "cachedCurrency",
    value: function cachedCurrency() {
      var _this$app$modules,
        _this$app$modules$ret,
        _this2 = this;
      var mixin = (_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$ret = _this$app$modules.returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'Mixin');
      var currencies = Array.isArray(mixin === null || mixin === void 0 ? void 0 : mixin.available_currencies) ? mixin.available_currencies : [];
      return currencies.find(function (currency) {
        return String((currency === null || currency === void 0 ? void 0 : currency.ticker) || '').trim().toUpperCase() === _this2.ticker;
      }) || null;
    }
  }, {
    key: "checkForLocalCrypto",
    value: function () {
      var _checkForLocalCrypto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(session) {
        var currency, _cm$options, cm, balance, _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              currency = this.crypto_selected;
              if (currency) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              cm = this.app.wallet.returnCryptoModuleByTicker(currency.ticker);
              if (cm !== null && cm !== void 0 && (_cm$options = cm.options) !== null && _cm$options !== void 0 && _cm$options.isActivated) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return cm.activate();
            case 3:
              _t2 = Number;
              _context2.n = 4;
              return cm.getAvailableBalance();
            case 4:
              balance = _t2(_context2.v);
              if (this.session === session && this.crypto_selected === currency && Number.isFinite(balance)) {
                currency.available_balance = balance;
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t3 = _context2.v;
              console.error('Store: web3 wallet balance check failed', _t3);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5]]);
      }));
      function checkForLocalCrypto(_x2) {
        return _checkForLocalCrypto.apply(this, arguments);
      }
      return checkForLocalCrypto;
    }()
  }, {
    key: "canPayFromWallet",
    value: function canPayFromWallet() {
      var _this$crypto_selected;
      var balance = Number((_this$crypto_selected = this.crypto_selected) === null || _this$crypto_selected === void 0 ? void 0 : _this$crypto_selected.available_balance);
      var deposit = Number(this.expected_deposit);
      return !!this.destination && Number.isFinite(balance) && Number.isFinite(deposit) && deposit > 0 && balance >= deposit;
    }
  }, {
    key: "requestAddress",
    value: function () {
      var _requestAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$app$modules2,
          _this$app$modules2$re,
          _this3 = this;
        var peerKey, deposit, initiator, session;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              peerKey = (_this$app$modules2 = this.app.modules) === null || _this$app$modules2 === void 0 || (_this$app$modules2$re = _this$app$modules2.returnModule) === null || _this$app$modules2$re === void 0 || (_this$app$modules2$re = _this$app$modules2$re.call(_this$app$modules2, 'Mixin')) === null || _this$app$modules2$re === void 0 || (_this$app$modules2$re = _this$app$modules2$re.buysaito_peer) === null || _this$app$modules2$re === void 0 ? void 0 : _this$app$modules2$re.publicKey;
              deposit = Number(this.expected_deposit);
              _context3.n = 1;
              return this.app.wallet.getPublicKey();
            case 1:
              initiator = _context3.v;
              this.payer = initiator;
              if (!(!peerKey || !initiator || !this.purchase_tx || !Number.isFinite(deposit) || deposit <= 0)) {
                _context3.n = 2;
                break;
              }
              this.fail('A valid payment amount is required.');
              return _context3.a(2);
            case 2:
              this.clearInstructionTimer();
              session = this.session;
              this.instruction_timer = setTimeout(function () {
                if (!_this3.active || _this3.session !== session || _this3.destination) {
                  return;
                }
                _this3.fail('The payment service did not return instructions. Please check your connection and try again.');
              }, INSTRUCTION_TIMEOUT_MS);
              this.app.network.sendRequestAsTransaction('buysaito reserve address', {
                initiator_pubkey: initiator,
                recipient_pubkey: initiator,
                ticker: this.ticker,
                expected_deposit: deposit,
                tx: this.purchase_tx.serialize_to_web(this.app)
              }, null, peerKey);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function requestAddress() {
        return _requestAddress.apply(this, arguments);
      }
      return requestAddress;
    }()
  }, {
    key: "receiveAddress",
    value: function receiveAddress(data) {
      if (!this.active || !this.ticker) {
        return;
      }
      if (String((data === null || data === void 0 ? void 0 : data.ticker) || '').trim().toUpperCase() !== this.ticker) {
        return;
      }
      this.clearInstructionTimer();
      if (!(data !== null && data !== void 0 && data.address) || !(data !== null && data !== void 0 && data.mixin_id)) {
        this.fail('The payment service returned incomplete deposit instructions.');
        return;
      }
      if (!this.reservation || this.reservation.id !== data.id || this.destination !== data.address) {
        this.reservation = data;
        this.payment_detected = false;
        this.internal_payment_pending = false;
        this.internal_payment_sending = false;
      }
      this.destination = data.address;
      this.mixin_id = data.mixin_id;
      if (data.expected_deposit) {
        this.expected_deposit = data.expected_deposit;
      }
      this.reserved_until = Number(data.reserved_until) || 0;
      this.statusLead = '';
      if (['pending', 'confirmed', 'issuing'].includes(data.status)) {
        this.receivePaymentDetected(data);
        return;
      }
      this.startReservationTimeout(this.reserved_until);
      this.render();
    }
  }, {
    key: "receivePaymentDetected",
    value: function receivePaymentDetected(data) {
      if (!this.active || !this.reservation || (data === null || data === void 0 ? void 0 : data.id) !== this.reservation.id || (data === null || data === void 0 ? void 0 : data.address) !== this.destination || String((data === null || data === void 0 ? void 0 : data.ticker) || '').trim().toUpperCase() !== this.ticker || !['pending', 'confirmed', 'issuing'].includes(data.status)) {
        return;
      }
      this.payment_detected = true;
      this.clearReservationTimer();
      if (data.status === 'pending') {
        this.statusLead = 'Payment detected. Completing your purchase...';
        this.render();
        return;
      }
      this.openFulfillmentMonitor();
    }
  }, {
    key: "openFulfillmentMonitor",
    value: function openFulfillmentMonitor() {
      var _this$summary, _this$mod;
      if (this.fulfillment_monitor) {
        return;
      }
      var nftId = String(((_this$summary = this.summary) === null || _this$summary === void 0 ? void 0 : _this$summary.nft_id) || '').trim();
      var monitor = (_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.transaction_monitor;
      if (!monitor || !nftId) {
        this.statusLead = 'Payment received. Completing your purchase...';
        this.render();
        return;
      }
      this.fulfillment_monitor = true;
      this.active = false;
      this.clearTimers();
      this.overlay.close();
      monitor.render({
        nft_id: nftId,
        title: 'Payment Confirmed',
        lead: 'The Store is fulfilling your order…',
        subtitle: ''
      });
    }
  }, {
    key: "receiveIssued",
    value: function receiveIssued() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.active || !this.reservation || data.id !== this.reservation.id || data.address !== this.destination || String(data.ticker || '').trim().toUpperCase() !== this.ticker) {
        return;
      }
      this.payment_detected = true;
      this.fundsNotice = false;
      this.clearTimers();
      this.openFulfillmentMonitor();
    }
  }, {
    key: "showInsufficientFunds",
    value: function showInsufficientFunds() {
      this.clearTimers();
      this.fundsNotice = true;
      this.followupError = '';
      this.render();
    }
  }, {
    key: "submitFollowupEmail",
    value: function submitFollowupEmail(raw) {
      var _this$summary2, _this$reservation;
      var email = String(raw || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.followupError = 'Enter an email address to be notified.';
        this.render();
        return;
      }
      var sent = sendInsufficientFundsFollowup(this.app, {
        email: email,
        title: this.title,
        payment: this.amountLabel(),
        nftId: (_this$summary2 = this.summary) === null || _this$summary2 === void 0 ? void 0 : _this$summary2.nft_id,
        publicKey: this.payer,
        reservationId: (_this$reservation = this.reservation) === null || _this$reservation === void 0 ? void 0 : _this$reservation.id
      });
      if (!sent) {
        this.followupError = 'The notice could not be sent. Email info@saito.io for assistance.';
        this.render();
        return;
      }
      this.followupEmail = email;
      this.followupSent = true;
      this.followupError = '';
      this.render();
    }
  }, {
    key: "receiveError",
    value: function receiveError() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.active) {
        return;
      }
      if ((data === null || data === void 0 ? void 0 : data.code) === 'insufficient_funds') {
        if (!this.reservation || data.id !== this.reservation.id || data.ticker !== this.ticker || data.address !== this.destination) {
          return;
        }
        this.showInsufficientFunds();
        return;
      }
      if (!(data !== null && data !== void 0 && data.message)) {
        return;
      }
      this.clearTimers();
      this.reservation = null;
      this.fail(data.message);
    }
  }, {
    key: "receiveStorePurchase",
    value: function receiveStorePurchase() {
      var _tx$returnMessage, _this$summary3, _this$mod$main2;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        conf = _ref2.conf,
        tx = _ref2.tx;
      if (!this.active || Number(conf) !== 0 || !tx) {
        return;
      }
      var txmsg = ((_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
      if (txmsg.module !== 'Store' || txmsg.request !== 'purchase-asset') {
        return;
      }
      if (String(txmsg.nft_id || '') !== String(((_this$summary3 = this.summary) === null || _this$summary3 === void 0 ? void 0 : _this$summary3.nft_id) || '')) {
        return;
      }
      if (String(txmsg.web3_ticker || '').trim().toUpperCase() !== this.ticker) {
        return;
      }
      var buyer = String(txmsg.buyer || '').trim();
      if (buyer && this.payer && buyer !== this.payer) {
        return;
      }
      var signature = tx.signature || '';
      var title = this.title;
      var summary = this.summary;
      var quantity = this.quantity;
      this.active = false;
      this.clearTimers();
      this.overlay.close();
      var lifecycle = this.mod.purchase_lifecycle;
      if (lifecycle && signature) {
        lifecycle.begin({
          summary: summary,
          purchaseTxSignature: signature,
          quantity: quantity
        });
        lifecycle.markPaymentConfirmed(signature);
      }
      var purchase = (_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 ? void 0 : _this$mod$main2.purchase_overlay;
      if (purchase) {
        purchase.listingTitle = title;
        purchase.pendingTxSignature = signature;
        purchase.nft_id = String((summary === null || summary === void 0 ? void 0 : summary.nft_id) || '');
        purchase.quantity = quantity;
        purchase.openFulfilling();
      }
    }
  }, {
    key: "payFromWallet",
    value: function () {
      var _payFromWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var reservation, sent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              reservation = this.reservation;
              if (!(!this.active || !reservation || this.payment_detected || this.internal_payment_pending || Date.now() >= Number(this.reserved_until) || !this.canPayFromWallet())) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.internal_payment_pending = true;
              this.internal_payment_sending = true;
              this.render();
              _context4.n = 2;
              return this.sendFromWallet();
            case 2:
              sent = _context4.v;
              if (!(!this.active || this.reservation !== reservation || this.payment_detected)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              this.internal_payment_sending = false;
              this.internal_payment_pending = sent;
              if (!sent) {
                this.statusLead = 'The wallet payment could not be sent. You can still pay the address below.';
              }
              this.render();
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function payFromWallet() {
        return _payFromWallet.apply(this, arguments);
      }
      return payFromWallet;
    }()
  }, {
    key: "sendFromWallet",
    value: function () {
      var _sendFromWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var cm, toAddress, result, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              cm = this.app.wallet.returnCryptoModuleByTicker(this.ticker);
              if (!(!cm || !this.destination || !this.mixin_id)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, false);
            case 1:
              toAddress = "".concat(this.destination, "|").concat(this.mixin_id, "|mixin");
              _context5.n = 2;
              return cm.sendPayment(this.expected_deposit, toAddress, 'success');
            case 2:
              result = _context5.v;
              return _context5.a(2, typeof result === 'string' && result.trim().length > 0);
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error('Store: web3 wallet payment failed', _t4);
              return _context5.a(2, false);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function sendFromWallet() {
        return _sendFromWallet.apply(this, arguments);
      }
      return sendFromWallet;
    }()
  }, {
    key: "fail",
    value: function fail(message) {
      this.addressRequestFailed = true;
      this.statusLead = message;
      this.destination = '';
      this.render();
      salert(message);
    }
  }, {
    key: "amountLabel",
    value: function amountLabel() {
      var amount = this.app.browser.formatDecimals(this.expected_deposit, true);
      return "".concat(amount, " ").concat(this.ticker);
    }
  }, {
    key: "productLabel",
    value: function productLabel() {
      var name = this.title || 'this item';
      return this.quantity > 1 ? "Purchase ".concat(name, " \xD7 ").concat(this.quantity) : "Purchase ".concat(name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$crypto_selected2,
        _this4 = this;
      if (!this.active) {
        return;
      }
      var canPayFromWallet = this.canPayFromWallet();
      var balance = (_this$crypto_selected2 = this.crypto_selected) === null || _this$crypto_selected2 === void 0 ? void 0 : _this$crypto_selected2.available_balance;
      this.overlay.show(Web3PaymentTemplate(this.app, {
        amountLabel: this.amountLabel(),
        productLabel: this.productLabel(),
        destination: this.destination,
        canPayFromWallet: canPayFromWallet,
        walletBalanceLabel: canPayFromWallet ? "".concat(this.app.browser.formatDecimals(balance, true), " ").concat(this.ticker) : '',
        processing: this.internal_payment_pending,
        statusLead: this.statusLead,
        fundsNotice: this.fundsNotice,
        followupSent: this.followupSent,
        followupEmail: this.followupEmail,
        followupError: this.followupError,
        awaitingAddress: !this.destination && !this.fundsNotice && !this.addressRequestFailed
      }), function () {
        _this4.active = false;
        _this4.clearTimers();
      });
      if (this.destination && !this.fundsNotice) {
        this.overlay.blockClose();
        this.app.browser.generateQRCode(this.destination, 'store-web3-qrcode');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this5 = this,
        _root$querySelector2,
        _root$querySelector3;
      var root = document.querySelector('.store-web3-payment');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('#store-web3-pay')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        _this5.payFromWallet();
      });
      (_root$querySelector2 = root.querySelector('.funds-notice-form')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = root.querySelector('#store-web3-followup-email');
        _this5.submitFollowupEmail(input === null || input === void 0 ? void 0 : input.value);
      });
      (_root$querySelector3 = root.querySelector('.address')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var icon, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (_this5.destination) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _context6.p = 1;
              _context6.n = 2;
              return navigator.clipboard.writeText(_this5.destination);
            case 2:
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t5 = _context6.v;
              console.warn('Store: copy payment address failed', (_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || _t5);
              return _context6.a(2);
            case 4:
              icon = root.querySelector('.address i');
              if (icon) {
                _context6.n = 5;
                break;
              }
              return _context6.a(2);
            case 5:
              icon.classList.toggle('fa-copy');
              icon.classList.toggle('fa-check');
              setTimeout(function () {
                icon.classList.toggle('fa-copy');
                icon.classList.toggle('fa-check');
              }, 800);
            case 6:
              return _context6.a(2);
          }
        }, _callee6, null, [[1, 3]]);
      })));
    }
  }, {
    key: "startReservationTimeout",
    value: function startReservationTimeout(expiryMs) {
      var _this6 = this;
      this.clearReservationTimer();
      if (this.payment_detected || !Number.isFinite(Number(expiryMs))) {
        return;
      }
      var session = this.session;
      this.reservation_timer = setTimeout(function () {
        if (!_this6.active || _this6.session !== session || _this6.payment_detected) {
          return;
        }
        var message = 'The payment time has timed out. Please try again.';
        _this6.active = false;
        _this6.clearTimers();
        _this6.overlay.close();
        salert(message);
      }, Math.max(0, Number(expiryMs) - Date.now()));
    }
  }, {
    key: "clearInstructionTimer",
    value: function clearInstructionTimer() {
      clearTimeout(this.instruction_timer);
      this.instruction_timer = null;
    }
  }, {
    key: "clearReservationTimer",
    value: function clearReservationTimer() {
      clearTimeout(this.reservation_timer);
      this.reservation_timer = null;
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      this.clearInstructionTimer();
      this.clearReservationTimer();
    }
  }]);
}();
module.exports = Web3PaymentOverlay;